import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { wrapper } from '../styles.js';
import { ThemeProvider } from 'styled-components';
import { useTheme } from '../../utils/theming/useTheme.js';

var _excluded = ["children", "$color"];
var TableContainer = function TableContainer(_ref) {
  var children = _ref.children,
    color = _ref.$color,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(wrapper, _extends({
    $color: color || theme.table.web.color
  }, props), children));
};

export { TableContainer };
